Application.Forms.Validators.ErrorMessageValidator = {
    onError: function (el, message) {

        var $el = $(el);
        $el.removeClass('error');

        var $wrappers = $el.parents('.select-wrapper, .checkbox-wrapper, .form-control');
        $wrappers.removeClass('error');

        // find control, error container and message
        var $control = $el.parents('.form-control');
        $control.find('.form-control__error').removeClass('form-control__error--active');

        setTimeout(function(){

            $el.focus();
            $el.attr('data-error-message', message);
            $el.addClass('error');

            $wrappers.addClass('error');

            $control.find('.form-control__error').addClass('form-control__error--active');
            $control.find('.form-control__error-text').text(message);

        }, 10);

    },
    onSuccess: function (el) {

        var $el = $(el);
        $el.removeAttr('data-error-message');
        $el.removeClass('error');

        var $wrappers = $el.parents('.select-wrapper, .checkbox-wrapper, .form-control')
        $wrappers.removeClass('error');

        // find control, error container and message
        var $control = $el.parents('.form-control');
        $control.find('.form-control__error').removeClass('form-control__error--active');
        $control.find('.form-control__error-text').text('');


    }
}